/**
 * This file contains the logout modal component for the settings page.
 */
import Buttons from '../../elements/modal/genericAcceptModalButtons';
import Container from '../../atoms/container/modalContainer';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useAppSelector } from '../../../../shared/store/hooks';
import { modalSelector } from '../../../../shared/store/slices/modal.slice';

/**
 * Logout modal component
 */
export default function LogoutModal() {
  // Selectors
  const { params } = useAppSelector(modalSelector);
  const { callback } = params;

  // Render
  return (
    <Container id={'logoutModalContainer'}>
      <Title>{TranslationManager.get('MODAL.LOGOUT.TITLE')}</Title>
      <Buttons
        acceptAction={callback ? (callback as () => void) : undefined}
        allowedBack={true}
      />
    </Container>
  );
}
